export default "__VITE_ASSET__BvrOUaJa__"